import TranslationText from '@Components/Utilities/TranslationText';
import { BaseTypography } from '@Components/MuiWrappers/Typography';
import translator from '@Components/Utilities/Translator';

const AdditionalInformation = (props) => {
    return (
        <BaseTypography className='additional-information'>
            <h4 className='additional-information__heading' style={{marginBottom: '8px'}}> <TranslationText tKey='sandhills.tradepubwebsite.mvc.additionalinformation' /> </h4>
            {props.AddInfo && props.AddInfo.length > 0 && props.AddInfo.map(info =>
                <a className='additional-information__link' href={info.SourceURL} target='_blank' content="noindex" aria-label={info.DisplayText + " (" + translator.translate('sandhills.opensinanewtab') + ")"} style={{width: '100%', display: 'inline-flex', marginBottom: '5px'}}>
                    <img className='additional-information__image' src={info.SiteArtImage} alt="" style={{maxHeight: '20px'}} />
                    <span className='additional-information__text'>{info.DisplayText}</span>
                </a>)}
        </BaseTypography>
    );
};

export default AdditionalInformation;